wbApp.factory('facebookSvc', ['$translate', 'tenantInfo', 'notificationSvc', 'tenantSettingSvc',
    function ($translate, tenantInfo, notificationSvc, tenantSettingSvc) {

        function getFeedDescriptionForCourse(subjectDescription, courseDescription) {
            var res = '';

            if (subjectDescription) {
                res = subjectDescription;
            }

            if (courseDescription) {
                if (res.length > 0) {
                    res = res + '.&nbsp;' + courseDescription;
                } else {
                    res = courseDescription;
                }
            }

            return res;
        }

        function shareCourseDetail(
            courseID,
            subjectName,
            courseFullName,
            subjectDescription,
            courseDescription,
            teacherFullName,
            picture,
            isAction) {

            var alias = tenantInfo.alias;
            var description = getFeedDescriptionForCourse(subjectDescription, courseDescription);
            var pictureUrl = !!picture
                ? picture
                : tenantSettingSvc.settings.registrationOpenPicture;
            var linkPart = isAction ? 'Actions' : 'Courses'

            var urlEncoded = encodeURI('https://' + alias + tenantInfo.domain + '/' + linkPart + '/Register/' + courseID);
            var titleEncoded = encodeURI(subjectName + ' ' + courseFullName + ' (' + teacherFullName + ')');
            var descriptionEncoded = encodeURI(description);
            var pictureUrlEncoded = encodeURI(pictureUrl);

            var socialMediaShareUrl = `https://${alias}${tenantInfo.domain}/spa-helper-social-media-share?url=${urlEncoded}&title=${titleEncoded}&image=${pictureUrlEncoded}&description=${descriptionEncoded}`;
                
            FB.ui({
                method: 'share',
                href: socialMediaShareUrl,
            }, function (response) { });
        }

        return {
            shareCourseDetail: shareCourseDetail
        }
    }
]);